<template>
	<div id="app">
		<!-- <Wiggle :processing="processing"></Wiggle> -->
		<div ref="glitterContainer" class="glitter-container"></div>
		<!-- <Header></Header> -->

		<Toggle></Toggle>

		<template v-if="init">
			<transition name="fade">
				<span class="c-spinner" v-if="processing"></span>
			</transition>
		</template>

		<div v-if="init" :class="['c-layout', { sidebar: showSidebar === true }]">
			<transition name="fade">
				<router-view />
			</transition>
		</div>

		<BulkEdit></BulkEdit>
		<Sidebar></Sidebar>

		<ModalLogin v-if="init"></ModalLogin>
		<ModalBoardCreate v-if="init"></ModalBoardCreate>
		<ModalAdCreate v-if="init"></ModalAdCreate>
		<ModalBoardUpdate v-if="init"></ModalBoardUpdate>
		<ModalFolderUpdate v-if="init"></ModalFolderUpdate>
		<ModalSettings v-if="init"></ModalSettings>
		<ModalOnboarding v-if="init"></ModalOnboarding>
		<ModalBlockView :standalone="standalone" v-if="init"></ModalBlockView>
		<ModalBlockCreate v-if="init"></ModalBlockCreate>
		<ModalExtensionHelper v-if="init"></ModalExtensionHelper>
		<ModalShare v-if="init"></ModalShare>
		<ModalShareAd v-if="init"></ModalShareAd>
		<ModalAfterUpgrade ref="modalafterupgrade"></ModalAfterUpgrade>
		<ModalMultiplayerTutorial v-if="init"></ModalMultiplayerTutorial>
		<ModalReward v-if="init"></ModalReward>
		<ModalBoardSave v-if="init"></ModalBoardSave>
		<ModalAddBrand v-if="init"></ModalAddBrand>
		<ModalFolderDeleteConfirmation v-if="init"></ModalFolderDeleteConfirmation>
		<ModalBoardDeleteConfirmation v-if="init"></ModalBoardDeleteConfirmation>

		<Message></Message>

		<!-- <TrialLine v-if="showTrialLine"></TrialLine> -->

		<!-- <Crop :cropActive="false"></Crop> -->
	</div>
</template>

<script>
import ModalLogin from '@swipekit/components/modal/modal-login';
import ModalAdCreate from '@swipekit/components/modal/modal-ad-create';
import ModalBoardCreate from '@swipekit/components/modal/modal-board-create';
import ModalBoardUpdate from '@swipekit/components/modal/modal-board-update';
import ModalFolderUpdate from '@swipekit/components/modal/modal-folder-update';
import ModalSettings from '@swipekit/components/modal/modal-settings';
import ModalOnboarding from '@swipekit/components/modal/modal-onboarding';
import ModalBlockView from '@swipekit/components/modal/modal-block-view';
import ModalBlockCreate from '@swipekit/components/modal/modal-block-create';
import ModalExtensionHelper from '@swipekit/components/modal/modal-extension-helper';
import ModalShare from '@swipekit/components/modal/modal-share';
import ModalShareAd from '@swipekit/components/modal/modal-share-ad';
import ModalReward from '@swipekit/components/modal/modal-reward';
import ModalBoardSave from '@swipekit/components/modal/modal-board-save';
import ModalAfterUpgrade from '@swipekit/components/modal/modal-after-upgrade';
import ModalAddBrand from '@swipekit/components/modal/modal-add-brand';
import ModalFolderDeleteConfirmation from '@swipekit/components/modal/modal-folder-delete-confirmation';
import ModalBoardDeleteConfirmation from '@swipekit/components/modal/modal-board-delete-confirmation';

import ModalMultiplayerTutorial from '@swipekit/components/multiplayer/modal-tutorial';
import Message from '@swipekit/components/message';
import api from '@swipekit/lib/api';
import BulkEdit from '@swipekit/components/bulk-edit';
import Sidebar from '@swipekit/components/sidebar';
import hotkeys from 'hotkeys-js';
import Toggle from '@swipekit/components/app/toggle.vue';

export default {
	components: {
		ModalLogin,
		ModalAdCreate,
		ModalBoardCreate,
		ModalBoardUpdate,
		ModalFolderUpdate,
		ModalSettings,
		ModalOnboarding,
		ModalBlockView,
		ModalBlockCreate,
		ModalExtensionHelper,
		ModalShare,
		ModalShareAd,
		ModalReward,
		ModalBoardSave,
		ModalAfterUpgrade,
		ModalMultiplayerTutorial,
		ModalAddBrand,
		ModalFolderDeleteConfirmation,
		ModalBoardDeleteConfirmation,
		Message,
		BulkEdit,
		Sidebar,
		Toggle,
	},

	computed: {
		init: function () {
			return this.$store.getters['app/init'];
		},
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
		processing: function () {
			return this.$store.getters['app/processing'];
		},
		standalone: function () {
			return this.$store.getters['standalone'];
		},
		showSidebar: function () {
			return this.$store.getters['app/showSidebar'];
		},
		auth: function () {
			let isAuth = this.$store.getters['users/isAuth'];

			return isAuth;
		},
		extensionId: function () {
			return this.$store.getters['extensionId'];
		},
		isDeactivated: function () {
			return this.$store.getters['users/isTrialOver'];
		},
		canUseCrisp: function () {
			return this.$store.getters['users/canUseCrisp'];
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
	},

	watch: {
		isDeactivated: function () {
			if (this.isDeactivated && this.$route.path !== '/mcp/authorize' && this.$route.path !== '/profile/billing') {
				this.$router.push({ path: '/profile/billing' });
			}
		},
		canUseCrisp: function (canUseCrisp) {
			this.$store.dispatch(canUseCrisp ? 'users/showCrisp' : 'users/hideCrisp');
		},
		auth: function () {
			this.sendTokenToChromeExtension();

			if (this.workspace) {
				console.log(this.workspace, this.workspace.activated);
			}
		},
	},

	methods: {
		async load() {
			await this.$store.dispatch('init').catch((err) => {
				console.log(err);
			});
		},

		async sendTokenToChromeExtension() {
			let token = (await api.users.getToken()) || '';
			if (!token) {
				return null;
			}
			let jwt = token;
			let extensionId = this.extensionId;
			if (typeof chrome === 'undefined') {
				return;
			}
			if (!chrome) {
				return;
			}
			if (!chrome.runtime) {
				return;
			}
			if (!chrome.runtime.sendMessage) {
				return;
			}
			chrome.runtime.sendMessage(
				extensionId,
				{ type: `auth`, jwt },
				(response) => {
					//console.log(response);
					//console.log('Handshake performed');
					this.$store.dispatch('setExtensionState', true);

					if (response && response.hasAuth && response.hasAuth === true) {
						//console.log('handshake was warm');
						this.$store.dispatch('message/onExtensionAuth');
					}
				}
			);
		},

		// Detects whether extension is installed or not
		async pingExtension() {
			let extensionId = this.extensionId;
			if (typeof chrome === 'undefined') {
				return;
			}
			if (!chrome.runtime) {
				return;
			}
			chrome.runtime.sendMessage(extensionId, { type: `ping` }, (response) => {
				//console.log('PINGED');
				// If u get this response, extension is installed
				this.$store.dispatch('setExtensionState', true);
			});
		},

		registerHotkeys: function () {
			hotkeys('esc', (event, handler) => {
				if (!this.isAuth) {
					return;
				}

				// hide bulk-edit modal
				this.$store.dispatch('ads/clearSelection');
			});
			hotkeys('alt+a', (event, handler) => {
				if (!this.isAuth) {
					return;
				}
				this.$router.push('/');
			});
			hotkeys('alt+s', (event, handler) => {
				if (!this.isAuth) {
					return;
				}
				this.$router.push('/multiplayer');
			});
			hotkeys('alt+d', (event, handler) => {
				if (!this.isAuth) {
					return;
				}
				this.$store.dispatch('app/toggleSidebar');
			});
		},
		checkIfUpgrade() {
			if (
				this.$route &&
				this.$route.query &&
				this.$route.query.billing &&
				this.$route.query.billing === 'successful'
			) {
				setTimeout(() => {
					this.$refs.modalafterupgrade.open();
				}, 4000);
			}
		},
		checkIfReferral() {
			if (this.$route && this.$route.query && this.$route.query.via) {
				const referral = this.$route.query.via;

				this.$store.dispatch('app/setReferral', referral);
			}
		},
		checkIfBlockId() {
			if (this.$route && this.$route.query && this.$route.query.blockid) {
				let blockid = this.$route.query.blockid;

				// Don't show the ad details page if they aren't onboarded
				if (!this.user.onboarded) {
					return;
				}

				if (blockid.length !== 36) {
					return;
				}

				setTimeout(() => {
					this.$store.dispatch('ads/setView', blockid);
				}, 4000);
			}
		},
		checkIfBoardSave() {
			if (
				this.$route &&
				this.$route.query &&
				this.$route.query['share-board']
			) {
				let boardId = this.$route.query['share-board'];

				boardId = parseInt(boardId);

				if (isNaN(boardId)) {
				} else {
					// trigger board save
					this.$store.dispatch('app/boardSave', boardId);
				}
			}
		},
	},

	mounted: function () {
		this.pingExtension();
		this.load().then(() => {
			// perform handshake everytime
			this.sendTokenToChromeExtension();

			this.checkIfBlockId();

		});
		//crop:active
		window.addEventListener('message', (e) => {
			//console.log(e);
		});

		this.registerHotkeys();

		this.checkIfUpgrade();

		this.checkIfReferral();

		this.checkIfBoardSave();

		// setInterval(() => {
		// 	let message = {
		// 		message: `Removing x from current board`,
		// 		timer: 3500,
		// 		status: 'success',
		// 	};
		// 	this.$store.dispatch('message/sendMessage', message);
		// }, 3000);
	},
};
</script>

<style lang="scss">
//@import '../node_modules/bootstrap/scss/bootstrap-grid.scss';
@import 'assets/styles/main.scss';

.v-popper__popper,
.tooltip {
	font-size: 13px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
		'Open Sans', 'Helvetica Neue', sans-serif;
	font-weight: 500;
	line-height: 1.4;
}

.v-popper--theme-tooltip .v-popper__inner,
.tooltip .tooltip-inner,
.tooltip .tooltip__inner {
	padding: 6px 10px;
	font-weight: 500;
	background-color: rgb(255, 255, 255);
	color: rgb(47, 47, 47);
	border: 1px solid rgb(223, 223, 223);
	border-radius: 4px;
	box-shadow: rgba(0, 0, 0, 0.02) 0px 3px 6px -2px, rgba(0, 0, 0, 0.043) 0px 1px 1px 0px;
}

.v-popper--theme-tooltip .v-popper__inner button,
.v-popper--theme-tooltip .v-popper__inner .btn,
.v-popper--theme-tooltip .v-popper__inner .tooltip-link,
.tooltip .tooltip-inner button,
.tooltip .tooltip-inner .btn,
.tooltip .tooltip-inner .tooltip-link,
.tooltip .tooltip__inner button,
.tooltip .tooltip__inner .btn,
.tooltip .tooltip__inner .tooltip-link {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin-top: 12px;
	margin-bottom: 0.25rem;
	padding: 8px 12px;
	border-radius: 0.5rem;
	background-color: #f3f3f3;
	color: #111827;
	font-weight: 540;
	text-decoration: none;
}

.v-popper--theme-tooltip .v-popper__arrow-inner {
	visibility: visible;
	border-color: rgb(255, 255, 255);
}

.v-popper--theme-tooltip .v-popper__arrow-outer,
.tooltip .tooltip-arrow,
.tooltip .tooltip__arrow {
	border-color: rgb(223, 223, 223);
}

.tooltip[x-placement^='top'] .tooltip-arrow,
.tooltip[x-placement^='top'] .tooltip__arrow {
	border-left-color: transparent !important;
	border-right-color: transparent !important;
	border-bottom-color: transparent !important;
}

.tooltip[x-placement^='bottom'] .tooltip-arrow,
.tooltip[x-placement^='bottom'] .tooltip__arrow {
	border-left-color: transparent !important;
	border-right-color: transparent !important;
	border-top-color: transparent !important;
}

.tooltip[x-placement^='right'] .tooltip-arrow,
.tooltip[x-placement^='right'] .tooltip__arrow {
	border-left-color: transparent !important;
	border-top-color: transparent !important;
	border-bottom-color: transparent !important;
}

.tooltip[x-placement^='left'] .tooltip-arrow,
.tooltip[x-placement^='left'] .tooltip__arrow {
	border-top-color: transparent !important;
	border-right-color: transparent !important;
	border-bottom-color: transparent !important;
}

#app {
	> .c-spinner {
		position: absolute;
		z-index: 999;
		top: 22px;
		right: 22px;
		width: 32px;
		height: 32px;
		border-width: 5px;
		border-color: var(--color-primary);
		border-bottom-color: transparent;
		background-color: hsl(var(--p), 40%, 99%);
		box-shadow: 0 0 0 8px hsl(var(--p), 40%, 99%);
		animation: rotation 750ms linear infinite;
	}
	.c-layout {
		container-type: inline-size;

		&.sidebar {
			margin-left: 300px;
			width: calc(100% - 300px);
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all 240ms cubic-bezier(0.215, 0.61, 0.355, 1);
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	.glitter {
		position: absolute;
		z-index: 999;
		width: 10px;
		height: 10px;
		background: red;
		border-radius: 50%;
		animation: glitter-animation 1s infinite;
	}

	@keyframes glitter-animation {
		0% {
			transform: translateY(0) rotate(0deg);
			opacity: 1;
		}
		100% {
			transform: translateY(300px) rotate(720deg);
			opacity: 0;
		}
	}

	@media (max-width: 768px) {
		.c-layout {
			&.sidebar {
				width: 100%;
				margin-left: 0;
			}
		}
	}
}
</style>
